import { useOrganization } from "@/contexts/OrganizationContext";

export const useOrgPermissions = () => {
  const { currentOrganization, memberships } = useOrganization();

  const getCurrentMembership = () => {
    if (!currentOrganization) return null;
    return memberships.find(m => m.organization_id === currentOrganization.id);
  };

  const hasRole = (roles: ('owner' | 'admin' | 'member')[]) => {
    const membership = getCurrentMembership();
    if (!membership) return false;
    return roles.includes(membership.role);
  };

  const canManageSettings = () => hasRole(['owner', 'admin']);
  const canManageBilling = () => hasRole(['owner']);
  const canManageTeam = () => hasRole(['owner', 'admin']);
  const isOwner = () => hasRole(['owner']);
  const isAdmin = () => hasRole(['admin']);
  const isMember = () => hasRole(['member']);

  return {
    canManageSettings,
    canManageBilling,
    canManageTeam,
    isOwner,
    isAdmin,
    isMember,
    role: getCurrentMembership()?.role
  };
};
